import { render, staticRenderFns } from "./InvoiceDetailsModal.vue?vue&type=template&id=490008b6&scoped=true&"
import script from "./InvoiceDetailsModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDetailsModal.vue?vue&type=style&index=0&id=490008b6&prod&lang=css&"
import style1 from "./InvoiceDetailsModal.vue?vue&type=style&index=1&id=490008b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490008b6",
  null
  
)

export default component.exports